import PropTypes from 'prop-types';
import React from 'react';
import Icon, { GLYPHS } from '../../components/Icon';

const AskForSMSConsentModalContents = ({ close, shopName }) => (
  <div>
    <div className="c-icon">
      <Icon glyph={GLYPHS.SMS} />
    </div>

    <p className="heading">{shopName} wants to keep in touch!</p>

    <p className="u-text-extrasmall">
        By clicking &quot;Yes&quot; below you agree to receive automated promotional text messages
        at the mobile number you provided when booking your appointment.
    </p>

    <p className="u-text-extrasmall">
      Consent is not a condition of purchase. Text HELP for help and STOP to cancel.
      Msg and data rates may apply and msg rate varies. Not all carriers covered.
      View
      {' '}
      <a href="https://getsquire.com/terms-of-service" target="_blank" rel="noopener noreferrer">Terms</a>
      {' '}&amp;{' '}
      <a href="https://getsquire.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy</a>
      {' '}
      for more information.
    </p>

    <div className="c-buttons-container" >
      <button className="c-btn c-btn--primary" onClick={close(true)}>Yes</button>
      <button className="c-btn c-btn--secondary" onClick={close(false)}>Skip</button>
    </div>
  </div>);

AskForSMSConsentModalContents.propTypes = {
  close: PropTypes.func.isRequired,
  shopName: PropTypes.string.isRequired,
};

export default AskForSMSConsentModalContents;



// WEBPACK FOOTER //
// ./src/app/reservation/components/AskForSMSConsentContents.jsx